import { useSelector } from "react-redux";
import { asMenuItem, MenuItem } from "../../components/menu";
import { selectMe } from "../../redux/reducer/app-slice";

const ICON = { ios: "f7:person_fill", md: "material:account_circle" };

const MeButton = asMenuItem(({ onClick }) => {
  const me = useSelector(selectMe);
  return (
    <MenuItem
      className="me-entry"
      title={me ? `Ich bin: ${me.name}` : "Wer bist du?"}
      icon={ICON}
      tone="orange"
      onClick={onClick}
    />
  );
});

export default MeButton;
